import { createSelector } from 'reselect';

import { Store } from '../reducers/reducers';

const languageState = (store: Store) => store.language;

export const selectedLanguageSelector = createSelector(languageState, (language) => language.selectedLanguage);
